import { render } from "./CommonBankAccount.vue?vue&type=template&id=95a8d186"
import script from "./CommonBankAccount.vue?vue&type=script&lang=js"
export * from "./CommonBankAccount.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\head.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__